"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Storage =
/*#__PURE__*/
function () {
  function Storage(storage) {
    (0, _classCallCheck2.default)(this, Storage);

    if (storage === false) {
      this.storageEnabled = false;
    } else {
      this.localStorage = storage;
      this.storageEnabled = null;
    }
  }

  (0, _createClass2.default)(Storage, [{
    key: "isStorageEnabled",
    value: function isStorageEnabled() {
      if (this.storageEnabled !== null) {
        return this.storageEnabled;
      }

      try {
        var testKey = 'firealarm-test';
        var time = Date.now();
        this.localStorage.setItem(testKey, time);
        this.storageEnabled = this.localStorage.getItem(testKey) == time;
        this.localStorage.removeItem(testKey);
      } catch (e) {
        this.storageEnabled = false;
      }

      return this.storageEnabled;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      if (this.isStorageEnabled()) {
        return this.localStorage.getItem(key);
      }

      return null;
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this.isStorageEnabled()) {
        this.localStorage.removeItem(key);
      }
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      if (this.isStorageEnabled()) {
        this.localStorage.setItem(key, value);
      }
    }
  }]);
  return Storage;
}();

;
var _default = Storage;
exports.default = _default;
module.exports = exports.default;